/* globals AmCharts */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ModalTable from './ModalTable';
import ModalList from './ModalList';
import Api from '../../services/ApiService';

const detailLookup = {
  salesPriorYear: 'Prior Year Sales',
  monthsNoSales: 'Months No Sale',
  priceSymbol: 'Price Symbol',
  supercedence: 'Supercedence',
  dateStocked: 'Stocking Date',
  onHand: 'On Hand',
  stockClass: 'Stock Class',
  description: 'Description',
  longDescription: 'Long Description',
  sortKey: 'Sort Key',
  returnCode: 'Return Code',
  stockCode: 'Stock Code',
  unitPackage: 'Unit Pack',
  loc: 'Bin Location',
  loc2: '2nd Bin Location',
  orderCntrl: 'Order Control',
  spclPrcFlg: 'Special Pricing Flag',
  superFrom: "Super'd From",
  maximum: 'Maximum Order',
  minimum: 'Minimum Order',
  memo: 'Memo',
  memoOrder: 'Order Memo',
  portalText: 'Portal Text',
};

const ModalDetail = ({ branchId, lookupKey, view = 'detail', setTitle }) => {
  const [details, setDetails] = useState({});
  const [prices, setPrices] = useState({});

  let chart;

  const chartConfig = {
    type: 'serial',
    categoryField: 'date',
    graphs: [
      {
        bullet: 'round',
        valueField: 'value',
        balloonText:
          '<div style="margin:5px; font-size:19px;"><span style="font-size:13px;">[[category]]</span><br>[[value]]</div>',
      },
    ],
    valueAxis: { labelsEnabled: true },
    export: { enabled: true },
    pathToImages: '/img/amcharts/',
  };

  /*
    Chart data from the backend is in this format: { key: [ xvalue, yvalue ] }
    We want it in this format [{ date: xvalue, value: yvalue }]
    Not sure if the key is important, but it is not maintained
   */
  const parseSalesData = (data = {}) => {
    const newData = [];
    Object.keys(data).forEach(key => {
      newData.push({ date: data[key][0], value: data[key][1] });
    });
    return newData;
  };

  const getData = () => {
    const query = branchId !== undefined ? `?branchId=${branchId}` : '';

    Api.get(`drilldown/${view}/${encodeURIComponent(lookupKey)}${query}`).then(response => {
      const { sales, details, prices } = response.data.data;
      chartConfig.dataProvider = parseSalesData(sales);
      chart = AmCharts.makeChart('modal-chart', chartConfig);
      setDetails(details);
      setPrices(prices);
    });

    setTitle(lookupKey);
  };

  useEffect(() => {
    getData();
    return () => {
      if (chart) {
        chart.clear();
      }
    };
  }, []);

  // Table, Chart, List
  return (
    <div className="modal-detail">
      <ModalTable data={prices.data} headers={prices.headers} />
      <div id="modal-chart" className="modal-chart" />
      <ModalList data={details} lookup={detailLookup} columns={2} />
    </div>
  );
};

ModalDetail.propTypes = {
  branchId: PropTypes.string,
  lookupKey: PropTypes.string,
  view: PropTypes.string,
  setTitle: PropTypes.func,
};

export default ModalDetail;
